import { render } from "./PartnerOptionsActionCard.vue?vue&type=template&id=8da3e9f6"
import script from "./PartnerOptionsActionCard.vue?vue&type=script&lang=js"
export * from "./PartnerOptionsActionCard.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__